/*!
 * @utiljs/cookie 0.1.3 (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/cookie/)
 * API http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/cookie/doc/api.md
 * Copyright 2017-2019 美团mfe. All Rights Reserved
 * Licensed under MIT (http://git.sankuai.com/projects/WM/repos/utiljs/browse/packages/cookie/LICENSE)
 */

/**
 * 设置 cookie
 *
 * @export
 * @param {string} cookieName 设置的 cookie 值名称
 * @param {string} cookieValue 设置的 cookie 值
 * @param { CookieOptions } [options] cookie 配置项
 * @returns {void}
 */
function setCookie(cookieName, cookieValue, options) {
    if (options === void 0) { options = {}; }
    var expires = options.expires;
    if (typeof cookieName !== 'string' || !cookieName.length) {
        return null;
    }
    var expiresStr = '';
    if (expires instanceof Date) {
        expiresStr = expires.toUTCString();
    }
    document.cookie = cookieName + '=' + encodeURIComponent(cookieValue || '') + '; path=/' + '; expires=' + expiresStr;
}
/**
 * 获取 cookie 值
 *
 * @export
 * @param {string} cookieName 要获取的 cookieName 值名称
 * @returns {string} cookie 值
 */
function getCookie(cookieName) {
    if (typeof cookieName !== 'string' || !cookieName.length) {
        return '';
    }
    var name = cookieName + '=';
    var cookies = document.cookie.split(';');
    for (var _i = 0, cookies_1 = cookies; _i < cookies_1.length; _i++) {
        var cookie = cookies_1[_i];
        var cookieStr = cookie.trim();
        if (cookieStr.indexOf(name) === 0) {
            return decodeURIComponent(cookieStr.substring(name.length, cookieStr.length));
        }
    }
    return '';
}
/**
 * 删除 cookie 值
 *
 * @export
 * @param {string} cookieName 要删除的 cookie 值名称
 */
function delCookie(cookieName) {
    if (typeof cookieName !== 'string' || !cookieName.length) {
        return;
    }
    var expires = new Date();
    expires.setTime(expires.getTime() - 1);
    var cookieValue = getCookie(cookieName) || '';
    document.cookie = cookieName + '=' + cookieValue + '; path=/; expires=' + expires.toUTCString();
}

export { setCookie, getCookie, delCookie };
